<h2 mat-dialog-title *ngIf="config.message">{{ config.message }}</h2>
<mat-dialog-content>
  <ng-template [ngIf]="config.indicatorType === 'spinner'" [ngIfThen]="spinnerTmpl"></ng-template>
  <ng-template [ngIf]="config.indicatorType === 'bar'" [ngIfThen]="barTmpl"></ng-template>
  <div class="downloadProgressInfo" *ngIf="secondsLeft || fileSize">
    <div class="remainingTime" *ngIf="secondsLeft">
      {{ 'common.estimatedTimeRemaining' | t }}: {{ secondsLeft | snDateDuration }}
    </div>
    <div class="fileSize" *ngIf="fileSize">
      {{ downloadedSize | snFilesize }} / {{ fileSize | snFilesize }}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
</mat-dialog-actions>
<ng-template #spinnerTmpl>
  <mat-spinner
    class="loading-spinner-center"
    [color]="config.color"
    [diameter]="config.diameter"
    [mode]="config.mode"
    [strokeWidth]="config.strokeWidth"
    [value]="percentDone"
  ></mat-spinner>
</ng-template>
<ng-template #barTmpl>
  <mat-progress-bar
    class="loading-progress-center"
    [color]="config.color"
    [diameter]="config.diameter"
    [mode]="config.mode"
    [strokeWidth]="config.strokeWidth"
    [value]="percentDone"
  ></mat-progress-bar>
</ng-template>
